module.exports = __webpack_public_path__ + "img/resident-statements-empty.2ab5fd31.png";